export default {
  appOwnership: 'standalone',
  deviceName: 'web',
  platform: {
    web: true,
  },
  manifest: {},
};
